let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("4vWCB")), load("9jv3V")]).then(() => parcelRequire('4POhN'));